export const TILE_FIELDS = {
  TITLE: 'title',
  BODY: 'body',
  EMBEDDEDLINK: 'embeddedLink',
  IMAGE: 'image',
  STATUS: 'status',
};
